import firebase from "firebase";
import MediaService from "../provider/media/MediaService";
import { CHANGE_APP_PROPS } from "./ActionConstants";

export function actionUploadFile(file, path, type, firebaseToken, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		var user = firebase.auth().currentUser;
		if (!user) {
			firebase
				.auth()
				.signInWithCustomToken(firebaseToken)
				.then(resp => {
					asyncUploadImage(file, path, type, callback)
						.then(response => {})
						.catch(error => {
							dispatch({
								type: CHANGE_APP_PROPS,
								props: {
									loading: false
								}
							});
						});
				})
				.catch(error => {
					console.log("error", error);
					dispatch({
						type: CHANGE_APP_PROPS,
						props: {
							loading: false
						}
					});
				});
		} else {
			asyncUploadImage(file, path, type, callback)
				.then(response => {})
				.catch(error => {
					console.log("error", error);
				});
		}
	};
}

async function asyncUploadImage(file, path, type, callback) {
	let response = await MediaService.uploadImage(file, path, type, callback);
	return response;
}

export function actionDeleteImage(path, firebaseToken, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true,
				loadingText: "Cargando ..."
			}
		});
		var user = firebase.auth().currentUser;
		if (!user) {
			firebase
				.auth()
				.signInWithCustomToken(firebaseToken)
				.then(resp => {
					asyncDeleteImage(path, callback)
						.then(response => {
							if (callback) {
								// callback;
							}
						})
						.catch(error => {
							// callback;
							dispatch({
								type: CHANGE_APP_PROPS,
								props: {
									loading: false,
									loadingText: "Cargando ..."
								}
							});
						});
				})
				.catch(error => {
					dispatch({
						type: CHANGE_APP_PROPS,
						props: {
							loading: false
						}
					});
				});
		} else {
			asyncDeleteImage(path, callback)
				.then(response => {
					// callback;
				})
				.catch(error => {
					// callback;
					dispatch({
						type: CHANGE_APP_PROPS,
						props: {
							loading: false,
							loadingText: "Cargando ..."
						}
					});
				});
		}
	};
}

async function asyncDeleteImage(path, callback) {
	let response = await MediaService.deleteImage(path, callback);
	return response;
}



// WEBPACK FOOTER //
// ./src/actions/MediaActions.js